import { render, staticRenderFns } from "./ReactContextMenu.vue?vue&type=template&id=470e7b54&scoped=true&"
import script from "./ReactContextMenu.vue?vue&type=script&lang=js&"
export * from "./ReactContextMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470e7b54",
  null
  
)

export default component.exports